import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { BaseWidget, NgAisInstantSearch } from 'angular-instantsearch';
import { connectPagination } from 'instantsearch.js/es/connectors';
import { CatalogPage } from '@vestiaire/api-sdk-angular';
import { PlatformService } from '@app/shared/services/platform/platform.service';
@Component({
  selector: 'vc-catalog-widget-pagination',
  templateUrl: './catalog-widget-pagination.component.html',
  styleUrls: ['./catalog-widget-pagination.component.scss']
})
export class CatalogWidgetPaginationComponent extends BaseWidget implements OnInit {
  @Input()
  public displayText = true;
  @Input()
  page: CatalogPage | null;
  public isCrawlable: boolean;
  public url: string;
  public state: {
    createURL: (page) => string;
    currentRefinement: number;
    nbHits: number;
    nbPages: number;
    pages: number[];
    isFirstPage: boolean;
    isLastPage: boolean;
    refine: (page) => void;
    widgetParams: any;
  };
  public SEORulesApply = true;
  private pagePadding = 5;
  private middleThresholdPage = 10;

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent: NgAisInstantSearch,
    private platformService: PlatformService
  ) {
    super('CatalogWidgetPaginationComponent');
  }

  ngOnInit() {
    this.createWidget(connectPagination, {
      padding: this.pagePadding
    });
    this.initPaginationCrawlable();
    this.SEORulesApply = this.platformService.isServer;
    super.ngOnInit();
  }

  refine(event: MouseEvent, page: number) {
    event.preventDefault();
    event.stopPropagation();

    if (page < 0 || page === this.state.currentRefinement || page >= this.state.nbPages) {
      return;
    }

    this.state.refine(page);
    window.scrollTo(0, 0);
  }

  initPaginationCrawlable(): void {
    if (this.page) {
      this.url = this.page.path;
      this.isCrawlable = this.page.indexation.crawlPagination;
    }
  }

  mapPages(pages: number[] = [], currentPage: number = 0) {
    return pages.filter(page => page >= currentPage && page <= currentPage + this.pagePadding);
  }

  getFinalBoundPageNumber(nbPages: number) {
    return nbPages > this.middleThresholdPage ? this.middleThresholdPage : nbPages;
  }
}
